import { render, staticRenderFns } from "./buyChannelEditor.vue?vue&type=template&id=a8d59b2c&scoped=true&"
import script from "./buyChannelEditor.vue?vue&type=script&lang=js&"
export * from "./buyChannelEditor.vue?vue&type=script&lang=js&"
import style0 from "./buyChannelEditor.vue?vue&type=style&index=0&id=a8d59b2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d59b2c",
  null
  
)

export default component.exports